'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../../../node_modules/classnames/index.js');
var React = require('react');
var Icon = require('../Icon/Icon.js');
var Explore = require('../BottomNavigation/FooterNavigation/Explore/Explore.js');
var Tools = require('../BottomNavigation/FooterNavigation/Tools/Tools.js');
var Insurance = require('../BottomNavigation/FooterNavigation/Insurance/Insurance.js');
var canUseWebp = require('../../utils/hooks/canUseWebp.js');
require('./ViewMore.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ViewMore = function (props) {
    var menu = props.menu, exploreProps = props.exploreProps, toolsProps = props.toolsProps, insuranceLinks = props.insuranceLinks;
    var _a = React.useState(false), isOpen = _a[0], setOpen = _a[1];
    var _b = React.useState(0), activeId = _b[0], setActiveId = _b[1];
    var loadContentComponent = function (id) {
        switch (id) {
            case 1:
                return (React__default['default'].createElement(Explore.Explore, { category: exploreProps.category, relatedPosts: exploreProps.relatedPosts, onBtnClick: function () { return setActiveId(0); } }));
            case 2:
                return (React__default['default'].createElement(Tools.Tools, { title: toolsProps.title, subtitle: toolsProps.subtitle, calculatorArticles: toolsProps.calculatorArticles, onBtnClick: function () { return setActiveId(0); } }));
            case 3:
                return (React__default['default'].createElement(Insurance.Insurance, { onBtnClick: function () { return setActiveId(0); }, insuranceLinks: insuranceLinks }));
        }
    };
    return (React__default['default'].createElement("div", { className: activeId > 0 ? 'viewMoreModal' : '' },
        React__default['default'].createElement("div", { className: "viewMoreContentWrapper" },
            React__default['default'].createElement("div", { className: "content" },
                React__default['default'].createElement("button", { className: "closeBtn", onClick: function () { return setActiveId(0); } }, "\u00D7"),
                React__default['default'].createElement("div", null, loadContentComponent(activeId)))),
        React__default['default'].createElement("div", { className: "viewMore" },
            React__default['default'].createElement("div", { className: index['default']('container', { '-hide': !isOpen }) }, menu.map(function (item) { return (React__default['default'].createElement("div", { className: "item" },
                React__default['default'].createElement(Icon.Icon, { className: index['default']('icon', canUseWebp.canUseWebp ? '-webp' : '-png', item.spriteSelector), onClick: function () {
                        return activeId === item.id ? setActiveId(0) : setActiveId(item.id);
                    }, noContent: true }),
                item.title)); })),
            React__default['default'].createElement(Icon.Icon, { className: index['default']('toggler', canUseWebp.canUseWebp ? '-webp' : '-png', isOpen ? '--open' : '--close'), onClick: function () {
                    setOpen(function (isOpen) { return !isOpen; });
                    isOpen && setActiveId(0);
                }, noContent: true }))));
};

exports.ViewMore = ViewMore;
//# sourceMappingURL=ViewMore.js.map
